// employeeSampleData.js

// Header order is fixed here so the CSV columns always match your import template
export const employeeCSVHeaders = [
  { label: "emp_id", key: "emp_id" },
  { label: "first_name", key: "first_name" },
  { label: "last_name", key: "last_name" },
  { label: "email", key: "email" },
  { label: "password", key: "password" },
  { label: "dob", key: "dob" },
  { label: "joining_date", key: "joining_date" },
  { label: "country_code", key: "country_code" },
  { label: "contact_number", key: "contact_number" },
  { label: "gender", key: "gender" },
  { label: "primary_department_id_list", key: "primary_department_id_list" },
  { label: "branch_id_list", key: "branch_id_list" },
  { label: "role", key: "role" },
  { label: "work_schedule", key: "work_schedule" },
  { label: "reporting_manager", key: "reporting_manager" },
  { label: "profile_timezone", key: "profile_timezone" },
  { label: "is_active", key: "is_active" },
  { label: "is_manager", key: "is_manager" },
  {
    label: "outside_range_notes_required",
    key: "outside_range_notes_required",
  },
];

export const employeeSampleData = [
  {
    emp_id: "EMP0001",
    first_name: "David",
    last_name: "Davis",
    email: "davis@example.com",
    password: "davis@123",
    dob: "1990-01-31",
    joining_date: "2024-01-02",
    country_code: "+91",
    contact_number: "9876500001",
    gender: 2,
    primary_department_id_list: "[1]",
    branch_id_list: "[1]",
    role: 3,
    work_schedule: 1,
    reporting_manager: "fayas@lintcloud.com",
    profile_timezone: "Asia/Kolkata",
    is_active: true,
    is_manager: true,
    outside_range_notes_required: true,
  },
  {
    emp_id: "EMP0002",
    first_name: "Michael",
    last_name: "Wilson",
    email: "wilson@example.com",
    password: "wilson@123",
    dob: "1990-03-02",
    joining_date: "2024-01-03",
    country_code: "+91",
    contact_number: "9876500002",
    gender: 1,
    primary_department_id_list: "[3]",
    branch_id_list: "[1]",
    role: 3,
    work_schedule: 1,
    reporting_manager: "davis@example.com",
    profile_timezone: "Asia/Kolkata",
    is_active: true,
    is_manager: false,
    outside_range_notes_required: true,
  },
  {
    emp_id: "EMP0003",
    first_name: "Michael",
    last_name: "Thomas",
    email: "thomas@example.com",
    password: "thomas@123",
    dob: "1990-04-01",
    joining_date: "2024-01-04",
    country_code: "+91",
    contact_number: "9876500003",
    gender: 1,
    primary_department_id_list: "[3]",
    branch_id_list: "[1]",
    role: 3,
    work_schedule: 1,
    reporting_manager: "davis@example.com",
    profile_timezone: "Asia/Kolkata",
    is_active: true,
    is_manager: true,
    outside_range_notes_required: true,
  },
  {
    emp_id: "EMP0004",
    first_name: "Jane",
    last_name: "Brown",
    email: "jane@example.com",
    password: "jane@123",
    dob: "1990-05-01",
    joining_date: "2024-01-05",
    country_code: "+91",
    contact_number: "9876500004",
    gender: 2,
    primary_department_id_list: "[3]",
    branch_id_list: "[1]",
    role: 3,
    work_schedule: 1,
    reporting_manager: "thomas@example.com",
    profile_timezone: "Asia/Kolkata",
    is_active: true,
    is_manager: false,
    outside_range_notes_required: true,
  },
  {
    emp_id: "EMP0005",
    first_name: "Daniel",
    last_name: "Johnson",
    email: "daniel@example.com",
    password: "daniel@123",
    dob: "1990-05-31",
    joining_date: "2024-01-06",
    country_code: "+91",
    contact_number: "9876500005",
    gender: 1,
    primary_department_id_list: "[3]",
    branch_id_list: "[1]",
    role: 3,
    work_schedule: 1,
    reporting_manager: "davis@example.com",
    profile_timezone: "Asia/Kolkata",
    is_active: true,
    is_manager: false,
    outside_range_notes_required: true,
  },
];
